import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faArrowDown,
	faBars,
	faCalendarDays,
	faChevronDown,
	faChevronUp,
	faCircleCheck,
	faEnvelope,
	faGlobe,
	faPersonBiking,
	faPhone,
	faRulerCombined,
	faTimes,
	faUsers,
	faForkKnife,
	faDumbbell,
	faBicycle,
	faVault,
	faCoffeePot,
	faTv,
	faTaxiBus,
	faVacuum,
	faWashingMachine,
	faThumbsUp,
	faCommentExclamation,
	faCircleInfo,
	faToothbrush,
} from '@fortawesome/pro-light-svg-icons';

import {
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTiktok,
	faTwitter,
	faWhatsapp,
	faXTwitter,
	faYoutube,
	faChromecast,
} from '@fortawesome/free-brands-svg-icons';

import {
	faArrows,
	faBedAlt,
	faBellConcierge,
	faCheck,
	faEuroSign,
	faMinus,
	faPlay,
	faPlus,
	faQuoteLeft,
	faSearch,
	faStar,
	faStarHalf,
	faStars,
} from '@fortawesome/pro-solid-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faArrowDown,
	faArrows,
	faBars,
	faBedAlt,
	faBellConcierge,
	faCalendarDays,
	faCheck,
	faChevronDown,
	faChevronUp,
	faCircleCheck,
	faEnvelope,
	faEuroSign,
	faFacebook,
	faGlobe,
	faInstagram,
	faLinkedin,
	faMinus,
	faPersonBiking,
	faPhone,
	faPinterest,
	faPlay,
	faPlus,
	faQuoteLeft,
	faRulerCombined,
	faSearch,
	faSoundcloud,
	faSpotify,
	faStar,
	faStarHalf,
	faStars,
	faTiktok,
	faTimes,
	faTwitter,
	faUsers,
	faUsers,
	faWhatsapp,
	faXTwitter,
	faYoutube,
	faChromecast,
	faForkKnife,
	faDumbbell,
	faBicycle,
	faVault,
	faCoffeePot,
	faTv,
	faTaxiBus,
	faVacuum,
	faWashingMachine,
	faThumbsUp,
	faCommentExclamation,
	faCircleInfo,
	faToothbrush,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
